import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CdsButtonModule } from '@cds/ng-web-components/button';

@Component({
  selector: 'app-updated-successfully',
  templateUrl: './updated-successfully.component.html',
  styleUrls: ['./updated-successfully.component.scss'],
  standalone: true,
  imports: [CdsButtonModule],
})
export class UpdatedSuccessfullyComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<UpdatedSuccessfullyComponent>>(MatDialogRef);

  ngOnInit(): void {}

  onCancel() {
    this.dialogRef.close({ agree: false });
  }
}
